export default {
	name: 'kh',
	custom:{
		email: {
	      	max: 'បំពេញអ៊ីម៉ែល ឫ លេខទូរស័ព្ទមិនអាចលើសពី100តួអក្សរ',
	      	email: 'ត្រូវបំពេញអ៊ីម៉ែលអោយបានត្រឹមត្រូវ'
	    },
		password:{
			required: 'តំរូវអោយបំពេញលេខសំងាត់',
			min: 'បំពេញលេខសំងាត់យ៉ាងតិចមាន8តួលេខ',
			max: 'បំពេញលេខសំងាត់មិនអាចលើសពី12តួលេខ'
		},
		password_confirmation:{
			required: 'តំរូវអោយបញ្ជាក់លេខសំងាត់ថ្មី',
			confirmed: 'ការបញ្ជាក់លេខសំងាត់គឺមិនត្រឹមត្រូវ',
		},
	    phone: {
	      	required: 'តំរូវអោយបំពេញលេខទូរស័ព្ទ',
	      	numeric: 'បំពេញលេខទូរស័ព្ទអាចជាតួលេខប៉ុណ្ណោះ',
	      	min: 'បំពេញលេខទូរស័ព្ទយ៉ាងតិចមាន9តួលេខ',
	      	max: 'បំពេញលេខទូរស័ព្ទមិនអាចលើសពី15តួលេខ'
	    },
	    otp: {
	      	required: 'តំរូវអោយបំពេញ OTP',
	      	numeric: 'បំពេញ OTP អាចជាតួលេខប៉ុណ្ណោះ',
			min: 'បំពេញ OTP យ៉ាងតិចមាន6តួលេខ',
	      	max: 'បំពេញ OTP មិនអាចលើសពី6តួលេខ'
	    },
		role_id: {
	      	required: 'តំរូវអោយបំពេញមុខងារ',
	    },
		name: {
	      	required: 'តំរូវអោយបំពេញឈ្មោះ',
			max: 'បំពេញឈ្មោះមិនអាចលើសពី50តួអក្សរ'
	    },
		company_name: {
	      	required: 'តំរូវអោយបំពេញឈ្មោះក្រុមហ៊ុន',
			max: 'ឈ្មោះក្រុមហ៊ុនមិនអាចលើសពី100តួអក្សរ'
	    },
		address: {
	      	required: 'តំរូវអោយបំពេញអាសយដ្ឋាន',
	      	max: 'បំពេញអាសយដ្ឋានមិនអាចលើសពី100តួអក្សរ'
	    },
	},
};
